"use client"

import { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { Users, FileText, PlusCircle, UserPlus, Shield, User,BarChart3 } from "lucide-react"
import UsersTab from "./users-tab"
import DailyReportTab from "./daily-report-tab"
import NewPlanTab from "./new-plan-tab"
import NewUserTab from "./new-user-tab"
// import AdminAccountsTab from "./admin-accounts-tab"
import AdminProfileTab from "./admin-profile-tab"
import PlansManagementTab from "./plans-management-tab"
export default function Dashboard() {
  const [activeTab, setActiveTab] = useState("users")

  const tabs = [
    { id: "users", label: "Users", icon: Users },
    { id: "new-user", label: "Add User", icon: UserPlus },
    { id: "plans", label: "Plans", icon: BarChart3 },
    // { id: "admin-accounts", label: "Admin Accounts", icon: Shield },
    { id: "admin-profile", label: "My Profile", icon: User },
    { id: "daily-report", label: "Send Daily Report", icon: FileText },
    { id: "new-plan", label: "Create New Plan", icon: PlusCircle },
  ]

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <header className="mb-8">
          <h1 className="text-3xl font-bold text-gray-800">Admin Dashboard</h1>
          <p className="text-gray-500">Manage users, reports, and investment plans</p>
        </header>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          {/* Tab Navigation */}
          <div className="flex border-b overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-6 py-4 font-medium transition-colors relative whitespace-nowrap ${
                  activeTab === tab.id ? "text-emerald-600" : "text-gray-500 hover:text-gray-700"
                }`}
              >
                <tab.icon size={18} />
                {tab.label}
                {activeTab === tab.id && (
                  <motion.div className="absolute bottom-0 left-0 right-0 h-0.5 bg-emerald-600" layoutId="activeTab" />
                )}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="p-6">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.2 }}
              >
                {activeTab === "users" && <UsersTab />}
                {activeTab === "new-user" && <NewUserTab />}
                {activeTab === "plans" && <PlansManagementTab />}
                {/* {activeTab === "admin-accounts" && <AdminAccountsTab />} */}
                {activeTab === "admin-profile" && <AdminProfileTab />}
                {activeTab === "daily-report" && <DailyReportTab />}
                {activeTab === "new-plan" && <NewPlanTab />}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  )
}

